import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ApiResult } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { SponsorBanner } from '@synergy/models';
import { base64encode } from '@synergy/utils';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';
import { SponsorBannerFormValues } from '../models/sponsor-banner-form-values';
import { sponsorBannerDetailRequestSelector } from './sponsor-banner-detail-selectors';

export const SPONSOR_BANNER_DETAIL_FETCH = 'SPONSOR_BANNER_DETAIL_FETCH';
export const SPONSOR_BANNER_DETAIL_RESET = 'SPONSOR_BANNER_DETAIL_RESET';
export const SPONSOR_BANNER_DETAIL_CREATE = 'SPONSOR_BANNER_DETAIL_CREATE';
export const SPONSOR_BANNER_DETAIL_UPDATE = 'SPONSOR_BANNER_DETAIL_UPDATE';
export const SPONSOR_BANNER_DETAIL_RECEIVE = 'SPONSOR_BANNER_DETAIL_RECEIVE';
export const SPONSOR_BANNER_DETAIL_ERROR = 'SPONSOR_BANNER_DETAIL_ERROR';

const receiveSponsorBannerDetail = (sponsorBanner: SponsorBanner) => {
    return {
        type: SPONSOR_BANNER_DETAIL_RECEIVE,
        sponsorBanner,
    };
};

const sponsorBannerDetailError = () => {
    return {
        type: SPONSOR_BANNER_DETAIL_ERROR,
    };
};

export const resetSponsorBannerDetail = () => {
    return {
        type: SPONSOR_BANNER_DETAIL_RESET,
    };
};

export const fetchSponsorBannerDetail = (id: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: SPONSOR_BANNER_DETAIL_FETCH });

        const response = await api.contentManagement.SponsorBanner.SponsorBannerDetail.getSponsorBannerDetail(id);

        if (response.success) {
            dispatch(receiveSponsorBannerDetail(response.result));
        } else {
            dispatch(sponsorBannerDetailError());
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveSponsorBannerDetail = (values: SponsorBannerFormValues, file?: File) => {
    return async (dispatch: ReduxDispatch, getState: () => AppState, { api }: { api: Api }) => {
        const fileBase64 = file ? { name: file.name, contentBase64: await base64encode(file) } : null;

        const sponsorBanner = sponsorBannerDetailRequestSelector(values, fileBase64)(getState());

        let response: ApiResult<SponsorBanner> | null = null;
        if (sponsorBanner.id) {
            dispatch({ type: SPONSOR_BANNER_DETAIL_UPDATE });
            response = await api.contentManagement.SponsorBanner.SponsorBannerDetail.updateSponsorBannerDetail(
                sponsorBanner
            );
        } else {
            dispatch({ type: SPONSOR_BANNER_DETAIL_CREATE });
            response = await api.contentManagement.SponsorBanner.SponsorBannerDetail.createSponsorBannerDetail(
                sponsorBanner
            );
        }

        if (response.success) {
            dispatch(receiveSponsorBannerDetail(response.result));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.sponsorBannerSaved')));
        } else {
            dispatch(sponsorBannerDetailError());
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
